import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { Navbar, Nav, NavDropdown, Container } from "react-bootstrap";
import logo from "../assets/logo.png";
import { FaUserCircle, FaHome, FaSearch, FaSlidersH } from "react-icons/fa";
import API_BASE_URL from "../config";

const ManagerNavbar = () => {
  const [openDropdown, setOpenDropdown] = useState(null);
  const [profile, setProfile] = useState({
    username: "Manager",
    role: "MANAGER",
    photo: null,
  });
  const [navbarColor, setNavbarColor] = useState(
    sessionStorage.getItem("managernavbarColor") || "#06205F"
  );

  const handleMouseEnter = (dropdown) => setOpenDropdown(dropdown);
  const handleMouseLeave = () => setOpenDropdown(null);
  const [companyLogo, setCompanyLogo] = useState(null);

  const navigate = useNavigate();
  const userId = sessionStorage.getItem("userId");
  const employeeId = sessionStorage.getItem("employeeId");
  const managerId = sessionStorage.getItem("employeeId");
  const token = sessionStorage.getItem("token");

  const handleGoToTeamTimesheets = () => {
    if (!managerId) {
      return console.error("Manager ID not set");
    }

    // Navigate using route param
    navigate(`/managertimesheetgrid/${managerId}`);
  };


  useEffect(() => {
    const bootstrapLink = document.createElement("link");
    bootstrapLink.rel = "stylesheet";
    bootstrapLink.href =
      "https://cdn.jsdelivr.net/npm/bootstrap@5.3.2/dist/css/bootstrap.min.css";
    document.head.appendChild(bootstrapLink);

    const iconsLink = document.createElement("link");
    iconsLink.rel = "stylesheet";
    iconsLink.href =
      "https://cdn.jsdelivr.net/npm/bootstrap-icons@1.11.1/font/bootstrap-icons.css";
    document.head.appendChild(iconsLink);

    return () => {
      bootstrapLink.remove();
      iconsLink.remove();
    };
  }, []);

  // 🔐 Authentication check
  useEffect(() => {
    const token = sessionStorage.getItem("token"); // or sessionStorage
    if (!token) {
      toast.error("You must be logged in to access this page.");
      navigate("/");
    }
  }, [navigate]);

  // useEffect(() => {
  //   console.log("User ID:", userId);
  //   console.log("Employee ID:", employeeId);
  //   console.log("Access token:", token);
  // }, []);

  const activeRole =
    sessionStorage.getItem("activeRole") ||
    (profile.role ? `ROLE_${profile.role.toUpperCase()}` : null);


  // 🟩 Fetch company info (logo)
  useEffect(() => {
    const token = sessionStorage.getItem("token");
    if (!token) return;

    fetch(`${API_BASE_URL}/api/company-info`, {
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "application/json",
      },
    })
      .then((res) => res.json())
      .then((data) => {
        if (Array.isArray(data) && data.length > 0) {
          const company = data[0];
          if (company.logoPath) {
            setCompanyLogo(`${API_BASE_URL}/${company.logoPath}`);
          }
        }
      })
      .catch((err) => console.error("Company logo fetch error:", err));
  }, []);

  // ✅ Fetch manager details
  useEffect(() => {
    const token = sessionStorage.getItem("token");
    const employeeId = sessionStorage.getItem("employeeId"); // Make sure this is set

    if (!token || !employeeId) return;

    fetch(`${API_BASE_URL}/api/users/employee/${employeeId}`, {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((res) => res.json())
      .then((data) => {
        if (data) {
          setProfile((prev) => ({
            ...prev,
            username: data.name || prev.username,
            roles: data.roles || ["ROLE_MANAGER"],
            role: data.roles?.includes("ROLE_MANAGER") ? "MANAGER" : prev.role,
          }));
        }
      })
      .catch((err) => console.error("Failed to fetch profile:", err));

    fetch(`${API_BASE_URL}/api/employees/me/photo`, {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((res) => res.blob())
      .then((blob) => {
        if (blob.size > 0) {
          setProfile((prev) => ({
            ...prev,
            photo: URL.createObjectURL(blob),
          }));
        }
      })
      .catch(() => console.log("No profile photo found"));
  }, []);

  return (
    <>
      {/* 🔹 Top White Bar */}
      <div
        className="d-flex align-items-center justify-content-between px-3 py-2 shadow-sm position-relative"
        style={{ backgroundColor: "#fff", borderBottom: "1px solid #ddd" }}
      >
        <div className="d-flex align-items-center">
          <img src={logo} style={{ height: "40px", marginRight: "45px" }} />

          {/* Company Logo (from API) */}
          {companyLogo && (
            <img
              src={companyLogo}
              alt="Company Logo"
              style={{
                height: "40px",
                width: "auto",
                objectFit: "contain",
                borderRadius: "6px",
              }}
            />
          )}
        </div>

        <div className="d-flex align-items-center gap-3">
          <a
            href="/managerdashboard"
            className="text-decoration-none text-dark d-flex align-items-center"
          >
            <FaHome className="me-1" size={23} />
          </a>
          <a
            href="/managersettings"
            className="text-decoration-none text-dark fw-semibold d-flex align-items-center"
          >
            <FaSlidersH className="me-1" size={19} /> Settings
          </a>

          {/* Profile Hover Dropdown */}
          <div
            className="position-relative"
            onMouseEnter={() => setOpenDropdown("profile")}
            onMouseLeave={handleMouseLeave}
          >
            <span
              className="d-flex align-items-center text-dark"
              style={{ cursor: "pointer" }}
            >
              <img
                src={profile.photo || "https://via.placeholder.com/24"}
                alt="Profile"
                style={{
                  width: "37px",
                  height: "37px",
                  borderRadius: "50%",
                  marginRight: "8px",
                }}
              />
              <div className="d-flex flex-column fw-semibold">
                <span>{profile.username}</span>
                <small className="text-muted">{profile.role}</small>
              </div>
            </span>

            {openDropdown === "profile" && (
              <div
                className="dropdown-menu show p-2"
                style={{
                  position: "absolute",
                  top: "100%",
                  right: 0,
                  zIndex: 2000,
                  minWidth: "220px",
                }}
              >
                <a className="dropdown-item" href="/managerprofile">
                  Profile Settings
                </a>
                <div className="dropdown-divider"></div>

                {profile.roles && profile.roles.length > 1 && (
                  <div className="px-2">
                    <h6 className="text-muted fw-bold mb-2">Switch Role</h6>
                    <table className="table table-sm mb-2">
                      <tbody>
                        {profile.roles
                          .filter(role => role !== activeRole)
                          .map((role, idx) => {
                            let path = "/";
                            if (role === "ROLE_MANAGER") path = "/managerdashboard";
                            if (role === "ROLE_ADMIN") path = "/admindashboard";
                            if (role === "ROLE_USER") path = "/empdashboard";

                            const isActive = role === activeRole;

                            return (
                              <tr key={idx}>
                                <td>
                                  <a
                                    href={path}
                                    className={`text-decoration-none d-block ${isActive ? "fw-bold text-primary" : ""
                                      }`}
                                    style={{
                                      pointerEvents: isActive ? "none" : "auto",
                                      opacity: isActive ? 0.6 : 1,
                                      cursor: isActive ? "default" : "pointer",
                                    }}
                                    onClick={(e) => {
                                      e.preventDefault();
                                      if (isActive) return;

                                      sessionStorage.setItem("activeRole", role);
                                      setProfile((prev) => ({
                                        ...prev,
                                        role: role.replace("ROLE_", ""),
                                      }));
                                      navigate(path);
                                    }}
                                  >
                                    {role.replace("ROLE_", "")}
                                    {isActive && (
                                      <span className="ms-2 badge bg-primary-subtle text-primary">
                                        Active
                                      </span>
                                    )}
                                  </a>
                                </td>
                              </tr>
                            );
                          })}
                      </tbody>

                    </table>
                  </div>
                )}

                <div className="dropdown-divider"></div>
                <a
                  className="dropdown-item text-danger"
                  href="#"
                  onClick={(e) => {
                    e.preventDefault();
                    sessionStorage.removeItem("token");
                    sessionStorage.removeItem("activeRole");
                    window.location.href = "/";
                  }}
                >
                  Logout
                </a>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* 🔹 Main Navbar */}
      <>
        <style>
          {`
            .navbar .dropdown-toggle::after {
              display: none !important;
            }
          `}
        </style>
        <Navbar
          expand="lg"
          variant="dark"
          className="shadow-sm"
          style={{
            backgroundColor: navbarColor,
            paddingTop: "0.05rem",
            paddingBottom: "0.05rem",
            minHeight: "40px",
          }}
        >
          <Container fluid>
            <Navbar.Toggle aria-controls="manager-navbar-nav" />
            <Navbar.Collapse id="manager-navbar-nav">
              <Nav className="me-auto fw-semibold">
                {/* Tasks */}
                <NavDropdown
                  title={
                    <span style={{ color: "#ffffff", fontWeight: "600" }} onClick={() => navigate("/managertasklanding")}>
                      Tasks
                    </span>
                  }
                  id="tasks-dropdown"
                  show={openDropdown === "tasks"}
                  onMouseEnter={() => handleMouseEnter("tasks")}
                  onMouseLeave={handleMouseLeave}
                >
                  <NavDropdown.Item href="/viewtaskss">
                    Task Management
                  </NavDropdown.Item>
                  {/* <NavDropdown.Item href="/viewteamtasks">
                    Abc
                  </NavDropdown.Item> */}
                </NavDropdown>

                {/* Timesheets */}
                <NavDropdown
                  title={
                    <span style={{ color: "#ffffff", fontWeight: "600" }} onClick={() => navigate("/managertimesheetlanding")}>
                      Timesheets
                    </span>
                  }
                  id="timesheets-dropdown"
                  show={openDropdown === "timesheets"}
                  onMouseEnter={() => handleMouseEnter("timesheets")}
                  onMouseLeave={handleMouseLeave}
                >
                  <NavDropdown.Item onClick={handleGoToTeamTimesheets}>
                    Timesheet Management
                  </NavDropdown.Item>
                  {/* <NavDropdown.Item href="#">
                    Abc
                  </NavDropdown.Item> */}
                </NavDropdown>

                {/* Leave */}
                <NavDropdown
                  title={
                    <span style={{ color: "#ffffff", fontWeight: "600" }} onClick={() => navigate("/managerleavelanding")}>
                      Leave
                    </span>
                  }
                  id="leave-dropdown"
                  show={openDropdown === "leave"}
                  onMouseEnter={() => handleMouseEnter("leave")}
                  onMouseLeave={handleMouseLeave}
                >
                  <NavDropdown.Item href="/managerteamleaves">
                    Leave Approvals
                  </NavDropdown.Item>
                  {/* <NavDropdown.Item href="/approveleaves">
                    Abc
                  </NavDropdown.Item> */}
                </NavDropdown>

                {/* Team */}
                <NavDropdown
                  title={
                    <span style={{ color: "#ffffff", fontWeight: "600" }} onClick={() => navigate("/managerteamlanding")}>
                      Team
                    </span>
                  }
                  id="team"
                  show={openDropdown === "docs"}
                  onMouseEnter={() => handleMouseEnter("docs")}
                  onMouseLeave={handleMouseLeave}
                >
                  <NavDropdown.Item href="/teampage">
                    Team Management
                  </NavDropdown.Item>
                  {/* <NavDropdown.Item href="/manageruploaddocuments">
                    Abc
                  </NavDropdown.Item> */}
                </NavDropdown>

                {/* Documents */}
                {/* <NavDropdown
                  title={
                    <span style={{ color: "#ffffff", fontWeight: "600" }}>
                      Documents
                    </span>
                  }
                  id="docs-dropdown"
                  show={openDropdown === "q"}
                  onMouseEnter={() => handleMouseEnter("q")}
                  onMouseLeave={handleMouseLeave}
                >
                  <NavDropdown.Item href="/teamdocuments">
                    Team Documents
                  </NavDropdown.Item>
                  <NavDropdown.Item href="/manageruploaddocuments">
                    Upload Documents
                  </NavDropdown.Item>
                </NavDropdown> */}
              </Nav>

              {/* 🔹 Search Bar */}
              <div
                className="ms-auto d-flex align-items-center"
                style={{ maxWidth: "250px", width: "100%" }}
              >
                <div
                  className="d-flex align-items-center border rounded px-2 w-100"
                  style={{ background: "#fff" }}
                >
                  <input
                    type="text"
                    placeholder="Search"
                    className="form-control border-0"
                    style={{ boxShadow: "none" }}
                  />
                  <FaSearch style={{ color: "#666" }} />
                </div>
              </div>
            </Navbar.Collapse>
          </Container>
        </Navbar>
      </>
    </>
  );
};

export default ManagerNavbar;
